export default "__VITE_ASSET__BOf__BQ___"